// `Color`: Represents the primary color palette with various shades and opacities.
//    - Includes legacy colors marked as deprecated.
//   - To update a color, modify the hex or rgba value associated with the desired color name.

export var Color;

// `ColorDark`: Represents the color palette for dark themes.
//     - Tailored for dark theme usage.
//     - Update colors by modifying the associated values.
(function (Color) {
  Color["White"] = "#fff";
  Color["White50"] = "rgba(255, 255, 255, 0.5)";
  Color["White40"] = "rgba(255, 255, 255, 0.4)";
  Color["White20"] = "rgba(255, 255, 255, 0.2)";
  Color["White10"] = "rgba(255, 255, 255, 0.1)";
  Color["White08"] = "rgba(255, 255, 255, 0.08)";
  Color["Transparent"] = "rgba(0, 0, 0, 0)";
  Color["Black"] = "#000";
  Color["Black50"] = "rgba(0, 0, 0, 0.5)";
  Color["Black20"] = "rgba(0, 0, 0, 0.2)";
  Color["Dark30"] = "rgba(143, 148, 158, 0.3)";
  Color["Blue30"] = "rgba(0, 112, 245, 0.3)";
  Color["Green30"] = "rgba(3, 135, 47, 0.3)";
  Color["Red30"] = "rgba(229, 35, 13, 0.3)";
  Color["Silver30"] = "rgba(225, 229, 234, 0.3)";
  Color["Blue10"] = "rgba(0, 112, 245, 0.1)";
  Color["Red10"] = "rgba(195, 25, 9, 0.1)";
  Color["Grey100"] = "#8F949E";
  Color["Grey200"] = "#6A707C";
  Color["Grey300"] = "#5B6371";
  Color["Grey400"] = "#323C4E";
  Color["Grey450"] = "#222F44";
  Color["Grey500"] = "#192334";
  Color["Dark200"] = "#6A707C";
  Color["Dark400"] = "#323C4E";
  Color["Dark450"] = "#222F44";
  Color["Silver100"] = "#F6F7F8";
  Color["Silver300"] = "#E8ECF0";
  Color["Blue75"] = "#CCE5FF";
  Color["Blue100"] = "#A8D1FF";
  Color["Blue200"] = "#66ADFF";
  Color["Blue400"] = "#0063DB";
  Color["Green75"] = "#C8F4D1";
  Color["Green100"] = "#90EAAE";
  Color["Green200"] = "#5DDA87";
  Color["Green400"] = "#1E8F46";
  Color["Purple75"] = "#DCDBF5";
  Color["Purple100"] = "#CBC8EE";
  Color["Purple200"] = "#A7A1E8";
  Color["Purple400"] = "#473ABB";
  Color["Red75"] = "#FDD9D3";
  Color["Red100"] = "#FDC2BA";
  Color["Red200"] = "#FE988B";
  Color["Red400"] = "#D9210D";
  Color["Teal75"] = "#BEEDF9";
  Color["Teal100"] = "#91E3F8";
  Color["Teal200"] = "#61D3EF";
  Color["Teal400"] = "#008DB8";
  Color["Yellow75"] = "#FFF1C2";
  Color["Yellow100"] = "#FFE494";
  Color["Yellow200"] = "#FFDC6B";
  Color["Yellow400"] = "#FFA91F";
  Color["Dark50"] = "rgba(25, 35, 52, 0.5)";
  Color["Dark100"] = "#8F949E";
  Color["Dark300"] = "#5B6371";
  Color["Dark500"] = "#192334";
  Color["Silver200"] = "#F3F5F8";
  Color["Silver400"] = "#E1E5EA";
  Color["Silver500"] = "#C4CDD5";
  Color["Silver400Alpha30"] = "rgba(225, 229, 234, 0.3)";
  Color["Blue50"] = "#EBF4FF";
  Color["Blue300"] = "#0070F5";
  Color["Blue500"] = "#0063DB";
  Color["Green50"] = "#ECF9EF";
  Color["Green300"] = "#03872F";
  Color["Green500"] = "#007A29";
  Color["Purple50"] = "#EFEEFC";
  Color["Purple300"] = "#6559CF";
  Color["Purple500"] = "#473ABB";
  Color["Red50"] = "#FFEDEB";
  Color["Red300"] = "#E5230D";
  Color["Red300Aplha20"] = "rgba(229, 35, 13, 0.2)";
  Color["Red500"] = "#C31909";
  Color["Teal50"] = "#E3F6FC";
  Color["Teal300"] = "#007EAB";
  Color["Teal500"] = "#00678A";
  Color["Yellow50"] = "#FFF7DC";
  Color["Yellow300"] = "#E8671C";
  Color["Yellow500"] = "#B84807";
})(Color || (Color = {}));
export var ColorDark;

// `ColorDynamic`: Represents a newer version of the color palette using CSS variables.
//   - Designed for more dynamic theming using CSS custom properties.
//   - Update colors by changing the CSS variable references.
(function (ColorDark) {
  ColorDark["White"] = "#151B22";
  ColorDark["White50"] = "rgba(21, 27, 34, 0.5)";
  ColorDark["White40"] = "rgba(21, 27, 34, 0.4)";
  ColorDark["White20"] = "rgba(21, 27, 34, 0.2)";
  ColorDark["White10"] = "rgba(21, 27, 34, 0.1)";
  ColorDark["White08"] = "rgba(21, 27, 34, 0.08)";
  ColorDark["Transparent"] = "rgba(0, 0, 0, 0)";
  ColorDark["Black"] = "#000";
  ColorDark["Black50"] = "rgba(0, 0, 0, 0.5)";
  ColorDark["Black20"] = "rgba(0, 0, 0, 0.2)";
  ColorDark["Dark30"] = "rgba(143, 148, 158, 0.3)";
  ColorDark["Blue30"] = "rgba(0, 112, 245, 0.3)";
  ColorDark["Green30"] = "rgba(3, 135, 47, 0.3)";
  ColorDark["Red30"] = "rgba(229, 35, 13, 0.3)";
  ColorDark["Silver30"] = "rgba(225, 229, 234, 0.3)";
  ColorDark["Blue10"] = "rgba(0, 112, 245, 0.1)";
  ColorDark["Red10"] = "rgba(195, 25, 9, 0.1)";
  ColorDark["Grey100"] = "#8F949E";
  ColorDark["Grey200"] = "#6A707C";
  ColorDark["Grey300"] = "#5B6371";
  ColorDark["Grey400"] = "#323C4E";
  ColorDark["Grey450"] = "#222F44";
  ColorDark["Grey500"] = "#192334";
  ColorDark["Dark200"] = "#6A707C";
  ColorDark["Dark400"] = "#323C4E";
  ColorDark["Dark450"] = "#222F44";
  ColorDark["Silver100"] = "#F6F7F8";
  ColorDark["Silver300"] = "#E8ECF0";
  ColorDark["Blue75"] = "#CCE5FF";
  ColorDark["Blue100"] = "#A8D1FF";
  ColorDark["Blue200"] = "#66ADFF";
  ColorDark["Blue400"] = "#0063DB";
  ColorDark["Green75"] = "#C8F4D1";
  ColorDark["Green100"] = "#90EAAE";
  ColorDark["Green200"] = "#5DDA87";
  ColorDark["Green400"] = "#1E8F46";
  ColorDark["Purple75"] = "#DCDBF5";
  ColorDark["Purple100"] = "#CBC8EE";
  ColorDark["Purple200"] = "#A7A1E8";
  ColorDark["Purple400"] = "#473ABB";
  ColorDark["Red75"] = "#FDD9D3";
  ColorDark["Red100"] = "#FDC2BA";
  ColorDark["Red200"] = "#FE988B";
  ColorDark["Red400"] = "#D9210D";
  ColorDark["Teal75"] = "#BEEDF9";
  ColorDark["Teal100"] = "#91E3F8";
  ColorDark["Teal200"] = "#61D3EF";
  ColorDark["Teal400"] = "#008DB8";
  ColorDark["Yellow75"] = "#FFF1C2";
  ColorDark["Yellow100"] = "#FFE494";
  ColorDark["Yellow200"] = "#FFDC6B";
  ColorDark["Yellow400"] = "#FFA91F";
  ColorDark["Dark50"] = "rgba(25, 35, 52, 0.5)";
  ColorDark["Dark100"] = "#6E7A8A";
  ColorDark["Dark300"] = "#AEB4BD";
  ColorDark["Dark500"] = "#FFFFFF";
  ColorDark["Silver200"] = "#0D1017";
  ColorDark["Silver400"] = "#30373D";
  ColorDark["Silver500"] = "#47505B";
  ColorDark["Silver400Alpha30"] = "rgba(48, 55, 61, 0.3)";
  ColorDark["Blue50"] = "#0E2947";
  ColorDark["Blue300"] = "#0070F5";
  ColorDark["Blue500"] = "#55ADFF";
  ColorDark["Green50"] = "#092E16";
  ColorDark["Green300"] = "#03872F";
  ColorDark["Green500"] = "#5EE18A";
  ColorDark["Purple50"] = "#262247";
  ColorDark["Purple300"] = "#6559CF";
  ColorDark["Purple500"] = "#BFA0FF";
  ColorDark["Red50"] = "#3D0A06";
  ColorDark["Red300"] = "#E5230D";
  ColorDark["Red300Aplha20"] = "rgba(233, 27, 12, 0.3)";
  ColorDark["Red500"] = "#FF6359";
  ColorDark["Teal50"] = "#11333D";
  ColorDark["Teal300"] = "#007EAB";
  ColorDark["Teal500"] = "#31C7F5";
  ColorDark["Yellow50"] = "#33200A";
  ColorDark["Yellow300"] = "#E8671C";
  ColorDark["Yellow500"] = "#FCA542";
})(ColorDark || (ColorDark = {}));
export var ColorDynamic;
(function (ColorDynamic) {
  ColorDynamic["White"] = "var(--sd-white)";
  ColorDynamic["White50"] = "var(--sd-white-50)";
  ColorDynamic["White40"] = "var(--sd-white-40)";
  ColorDynamic["White20"] = "var(--sd-white-20)";
  ColorDynamic["White10"] = "var(--sd-white-10)";
  ColorDynamic["White08"] = "var(--sd-white-08)";
  ColorDynamic["Transparent"] = "var(--sd-transparent)";
  ColorDynamic["Black"] = "var(--sd-black)";
  ColorDynamic["Black50"] = "var(--sd-black-50)";
  ColorDynamic["Black20"] = "var(--sd-black-20)";
  ColorDynamic["Dark30"] = "var(--sd-dark-30)";
  ColorDynamic["Blue30"] = "var(--sd-blue-30)";
  ColorDynamic["Green30"] = "var(--sd-green-30)";
  ColorDynamic["Red30"] = "var(--sd-red-30)";
  ColorDynamic["Silver30"] = "var(--sd-silver-30)";
  ColorDynamic["Blue10"] = "var(--sd-blue-10)";
  ColorDynamic["Red10"] = "var(--sd-red-10)";
  ColorDynamic["Grey100"] = "var(--sd-grey-100)";
  ColorDynamic["Grey200"] = "var(--sd-grey-200)";
  ColorDynamic["Grey300"] = "var(--sd-grey-300)";
  ColorDynamic["Grey400"] = "var(--sd-grey-400)";
  ColorDynamic["Grey450"] = "var(--sd-grey-450)";
  ColorDynamic["Grey500"] = "var(--sd-grey-500)";
  ColorDynamic["Dark200"] = "var(--sd-dark-200)";
  ColorDynamic["Dark400"] = "var(--sd-dark-400)";
  ColorDynamic["Dark450"] = "var(--sd-dark-450)";
  ColorDynamic["Silver100"] = "var(--sd-silver-100)";
  ColorDynamic["Silver300"] = "var(--sd-silver-300)";
  ColorDynamic["Blue75"] = "var(--sd-blue-75)";
  ColorDynamic["Blue100"] = "var(--sd-blue-100)";
  ColorDynamic["Blue200"] = "var(--sd-blue-200)";
  ColorDynamic["Blue400"] = "var(--sd-blue-400)";
  ColorDynamic["Green75"] = "var(--sd-green-75)";
  ColorDynamic["Green100"] = "var(--sd-green-100)";
  ColorDynamic["Green200"] = "var(--sd-green-200)";
  ColorDynamic["Green400"] = "var(--sd-green-400)";
  ColorDynamic["Purple75"] = "var(--sd-purple-75)";
  ColorDynamic["Purple100"] = "var(--sd-purple-100)";
  ColorDynamic["Purple200"] = "var(--sd-purple-200)";
  ColorDynamic["Purple400"] = "var(--sd-purple-400)";
  ColorDynamic["Red75"] = "var(--sd-red-75)";
  ColorDynamic["Red100"] = "var(--sd-red-100)";
  ColorDynamic["Red200"] = "var(--sd-red-200)";
  ColorDynamic["Red400"] = "var(--sd-red-400)";
  ColorDynamic["Teal75"] = "var(--sd-teal-75)";
  ColorDynamic["Teal100"] = "var(--sd-teal-100)";
  ColorDynamic["Teal200"] = "var(--sd-teal-200)";
  ColorDynamic["Teal400"] = "var(--sd-teal-400)";
  ColorDynamic["Yellow75"] = "var(--sd-yellow-75)";
  ColorDynamic["Yellow100"] = "var(--sd-yellow-100)";
  ColorDynamic["Yellow200"] = "var(--sd-yellow-200)";
  ColorDynamic["Yellow400"] = "var(--sd-yellow-400)";
  ColorDynamic["Dark50"] = "var(--sd-dark-50)";
  ColorDynamic["Dark100"] = "var(--sd-dark-100)";
  ColorDynamic["Dark300"] = "var(--sd-dark-300)";
  ColorDynamic["Dark500"] = "var(--sd-dark-500)";
  ColorDynamic["Silver200"] = "var(--sd-silver-200)";
  ColorDynamic["Silver400"] = "var(--sd-silver-400)";
  ColorDynamic["Silver500"] = "var(--sd-silver-500)";
  ColorDynamic["Silver400Alpha30"] = "var(--sd-silver-400-alpha-30)";
  ColorDynamic["Blue50"] = "var(--sd-blue-50)";
  ColorDynamic["Blue300"] = "var(--sd-blue-300)";
  ColorDynamic["Blue500"] = "var(--sd-blue-500)";
  ColorDynamic["Green50"] = "var(--sd-green-50)";
  ColorDynamic["Green300"] = "var(--sd-green-300)";
  ColorDynamic["Green500"] = "var(--sd-green-500)";
  ColorDynamic["Purple50"] = "var(--sd-purple-50)";
  ColorDynamic["Purple300"] = "var(--sd-purple-300)";
  ColorDynamic["Purple500"] = "var(--sd-purple-500)";
  ColorDynamic["Red50"] = "var(--sd-red-50)";
  ColorDynamic["Red300"] = "var(--sd-red-300)";
  ColorDynamic["Red500"] = "var(--sd-red-500)";
  ColorDynamic["Red300Aplha20"] = "var(--sd-red-300-alpha-20)";
  ColorDynamic["Teal50"] = "var(--sd-teal-50)";
  ColorDynamic["Teal300"] = "var(--sd-teal-300)";
  ColorDynamic["Teal500"] = "var(--sd-teal-500)";
  ColorDynamic["Yellow50"] = "var(--sd-yellow-50)";
  ColorDynamic["Yellow300"] = "var(--sd-yellow-300)";
  ColorDynamic["Yellow500"] = "var(--sd-yellow-500)";
})(ColorDynamic || (ColorDynamic = {}));
export function isColorProp(name) {
  return typeof name == 'string' && Object.prototype.hasOwnProperty.call(Color, name);
}
export function isColorDynamicProp(name) {
  return typeof name == 'string' && Object.prototype.hasOwnProperty.call(ColorDynamic, name);
}
export function isColorPropDark(name) {
  return typeof name == 'string' && Object.prototype.hasOwnProperty.call(ColorDark, name);
}